import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./auth";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Login } from "./screens/Login";
import { AcceptInvite } from "./screens/AcceptInvite";
import { ForgotPassword } from "./screens/ForgotPassword";
import { ResetPassword } from "./screens/ResetPassword";
import { Dashboard } from "./screens/Dashboard";
import { Khaata } from "./screens/Khaata";
import { KhaataDetail } from "./screens/KhaataDetail";
import { Transactions } from "./screens/Transactions";
import { Import } from "./screens/Import";
import { Vault } from "./screens/Vault";
import { Assets } from "./screens/Assets";
import { Loans } from "./screens/Loans";
import { Incomes } from "./screens/Incomes";
import { PnL } from "./screens/PnL";
import { CapGains } from "./screens/CapGains";
import { Tax } from "./screens/Tax";
import FileReturn from "./screens/FileReturn";
import { Reminders } from "./screens/Reminders";
import { SourceOfFunds } from "./screens/SourceOfFunds";
import { RunningAccount } from "./screens/RunningAccount";
import { Assistant } from "./screens/Assistant";
import { Review } from "./screens/Review";
import { Recon } from "./screens/Recon";
import { FamilyTax } from "./screens/FamilyTax";
import { Settings } from "./screens/Settings";

export function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/accept-invite" element={<AcceptInvite />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        {/* Gmail OAuth return: the server callback redirects here (an App Link
            path so native reopens the app); forward to Settings. */}
        <Route path="/gmail-return" element={<Navigate to="/settings?gmail=connected" replace />} />

        <Route
          path="/"
          element={
            <ProtectedRoute tenantOnly>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/khaata"
          element={
            <ProtectedRoute tenantOnly>
              <Khaata />
            </ProtectedRoute>
          }
        />
        <Route
          path="/khaata/:id"
          element={
            <ProtectedRoute tenantOnly>
              <KhaataDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/transactions"
          element={
            <ProtectedRoute tenantOnly>
              <Transactions />
            </ProtectedRoute>
          }
        />
        <Route
          path="/import"
          element={
            <ProtectedRoute tenantOnly>
              <Import />
            </ProtectedRoute>
          }
        />
        <Route
          path="/vault"
          element={
            <ProtectedRoute tenantOnly>
              <Vault />
            </ProtectedRoute>
          }
        />
        <Route
          path="/assets"
          element={
            <ProtectedRoute tenantOnly>
              <Assets />
            </ProtectedRoute>
          }
        />
        <Route
          path="/loans"
          element={
            <ProtectedRoute tenantOnly>
              <Loans />
            </ProtectedRoute>
          }
        />
        <Route
          path="/incomes"
          element={
            <ProtectedRoute tenantOnly>
              <Incomes />
            </ProtectedRoute>
          }
        />
        <Route
          path="/pnl"
          element={
            <ProtectedRoute tenantOnly>
              <PnL />
            </ProtectedRoute>
          }
        />
        <Route
          path="/capgains"
          element={
            <ProtectedRoute tenantOnly>
              <CapGains />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tax"
          element={
            <ProtectedRoute tenantOnly>
              <Tax />
            </ProtectedRoute>
          }
        />
        <Route
          path="/file-return"
          element={
            <ProtectedRoute tenantOnly>
              <FileReturn />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reminders"
          element={
            <ProtectedRoute tenantOnly>
              <Reminders />
            </ProtectedRoute>
          }
        />
        <Route
          path="/source-of-funds"
          element={
            <ProtectedRoute tenantOnly>
              <SourceOfFunds />
            </ProtectedRoute>
          }
        />
        <Route
          path="/running-account"
          element={
            <ProtectedRoute tenantOnly>
              <RunningAccount />
            </ProtectedRoute>
          }
        />
        <Route
          path="/assistant"
          element={
            <ProtectedRoute tenantOnly>
              <Assistant />
            </ProtectedRoute>
          }
        />
        <Route
          path="/review"
          element={
            <ProtectedRoute tenantOnly>
              <Review />
            </ProtectedRoute>
          }
        />
        <Route
          path="/recon"
          element={
            <ProtectedRoute tenantOnly>
              <Recon />
            </ProtectedRoute>
          }
        />
        <Route
          path="/family-tax"
          element={
            <ProtectedRoute tenantOnly>
              <FamilyTax />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}
